import React, { useEffect, useState } from 'react';
import OrderFilter from '../../../../Components2/common/OrderFilter';
import { useAuth0 } from '@auth0/auth0-react';
import { getFilterCentersAdmin } from '../../../../api/carteleriaApi';
import { useQuery } from '@tanstack/react-query';

const CenterUserFilter = ({ centersFilter, setCentersFilter }) => {
  const { getAccessTokenSilently } = useAuth0();
  const [filteredCenters, setFilteredCenters] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [openMenu, setOpenMenu] = useState(null);

  const handleMenuOpen = (menuName) => {
    setOpenMenu(menuName);
  };

  const { data: centers, isLoading: loadingCenters } = useQuery(['filter-centers'], async () => {
    const token = await getAccessTokenSilently();
    return await getFilterCentersAdmin(token);
  });

  useEffect(() => {
    const normalizeString = (str) => {
      return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
    };

    if (centers) {
      if (searchValue.length >= 3) {
        const normalizedSearchValue = normalizeString(searchValue);
        const filtered = centers.filter((center) => normalizeString(center.label).includes(normalizedSearchValue));
        setFilteredCenters(filtered);
      } else {
        setFilteredCenters(centers);
      }
    }
  }, [searchValue, centers]);

  return (
    <>
      <OrderFilter
        search={true}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        loading={loadingCenters}
        filterName="Centro"
        filterList={filteredCenters}
        filterValues={centersFilter}
        setFilterValues={setCentersFilter}
        openMenu={openMenu}
        handleMenuOpen={handleMenuOpen}
        menuName="Centro" // Nombre único para el menú
      />
    </>
  );
};

export default CenterUserFilter;
